import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Modal } from '../Modal';

interface MissingDateItem {
    file: File;
    category: string;
    preview: string;
}

interface Props {
    queue: MissingDateItem[];
    currentIndex: number;
    manualFileDate: string;
    setManualFileDate: (v: string) => void;
    onConfirm: () => void;
    onSkip: () => void;
}

export const MissingDateModal: React.FC<Props> = ({
    queue, currentIndex, manualFileDate, setManualFileDate, onConfirm, onSkip,
}) => {
    const item = queue[currentIndex];
    if (!item) return null;
    const isVideo = item.file.type.startsWith('video');

    return (
        <Modal
            title={`Data mancante o fuori range (${currentIndex + 1} di ${queue.length})`}
            onClose={() => {}}
        >
            <div className="space-y-4">
                <div className="bg-amber-50 text-amber-800 p-3 rounded-lg text-xs font-medium border border-amber-200 flex items-start gap-2">
                    <AlertTriangle size={16} className="shrink-0 mt-0.5" />
                    <p>Questo file non ha l'orario di scatto oppure è fuori dalle date dell'incarico (es. inoltrato su WhatsApp). Inserisci la data originale manualmente.</p>
                </div>

                <div className="flex justify-center bg-slate-100 p-2 rounded-xl overflow-hidden border border-slate-200 shadow-inner">
                    {isVideo ? (
                        <video src={item.preview} className="max-h-48 rounded object-contain" controls />
                    ) : (
                        <img src={item.preview} className="max-h-48 rounded object-contain" alt="preview" />
                    )}
                </div>

                <div>
                    <label className="text-[10px] font-bold text-slate-500 uppercase">Data e Ora dello Scatto Originale</label>
                    <input
                        type="datetime-local"
                        className="w-full p-3 mt-1 bg-white border border-slate-200 rounded-lg outline-none focus:ring-2 ring-blue-500 font-semibold text-slate-800"
                        value={manualFileDate}
                        onChange={e => setManualFileDate(e.target.value)}
                    />
                </div>

                <div className="flex gap-2 pt-2">
                    <button
                        onClick={onSkip}
                        className="flex-1 py-3 text-slate-500 font-bold hover:bg-slate-100 rounded-xl transition-colors"
                    >
                        Ignora e Scarta
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={!manualFileDate}
                        className="flex-[2] py-3 bg-blue-600 text-white font-bold rounded-xl disabled:opacity-50 transition-all shadow-md active:scale-95"
                    >
                        Conferma e Carica
                    </button>
                </div>
            </div>
        </Modal>
    );
};
